import React, {useState} from 'react';
import {RoundedCornerOutlined} from '@mui/icons-material';

import BaseSidebarPanel from './helpers/BaseSidebarPanel';
import ColorInput, {NullableColorInput} from './helpers/inputs/ColorInput';
import {NullableFontFamily} from './helpers/inputs/FontFamily';
import SliderInput from './helpers/inputs/SliderInput';
import EmailLayoutPropsSchema from "../../../documents/blocks/EmailLayout/EmailLayoutPropsSchema";


export default function EmailLayoutSidebarFields({data, setData}) {
    const [, setErrors] = useState(null);

    const updateData = (d) => {
        const res = EmailLayoutPropsSchema.safeParse(d);
        if (res.success) {
            setData(res.data);
            setErrors(null);
        } else {
            setErrors(res.error);
        }
    };

    return (
        <div className="position-relative">
            <BaseSidebarPanel>
                <ColorInput
                    label="Backdrop color"
                    defaultValue={data.backdropColor ?? '#F5F5F5'}
                    onChange={(backdropColor) => updateData({...data, backdropColor})}
                />
                <ColorInput
                    label="Canvas color"
                    defaultValue={data.canvasColor ?? '#FFFFFF'}
                    onChange={(canvasColor) => updateData({...data, canvasColor})}
                />
                <NullableColorInput
                    label="Canvas border color"
                    defaultValue={data.borderColor ?? null}
                    onChange={(borderColor) => updateData({...data, borderColor})}
                />
                <ColorInput
                    label="Text color"
                    defaultValue={data.textColor ?? '#262626'}
                    onChange={(textColor) => updateData({...data, textColor})}
                />
                <SliderInput
                    iconLabel={<RoundedCornerOutlined/>}
                    units="px"
                    step={4}
                    marks
                    min={0}
                    max={48}
                    label="Canvas border radius"
                    defaultValue={data.borderRadius ?? 0}
                    onChange={(borderRadius) => updateData({...data, borderRadius})}
                />
                <NullableFontFamily
                    label="Font family"
                    defaultValue={data?.fontFamily ?? 'MODERN_SANS'}
                    onChange={(fontFamily) => updateData({...data, fontFamily})}
                />
            </BaseSidebarPanel>
        </div>
    );
}
